module.exports = __webpack_public_path__ + "static/media/303ButtonLabel--waveform.04ba4135.svg";